import { TeamColors } from '@/types'

export const predefinedColor: TeamColors = {
  '200490': '#329999', // Cloud Decision Engine
  '200004': '#fbb3c3', // Fraud general prevention Europe
  '200003': '#57F7A1', // Fraud general prevention US UK
  '200002': '#5866CC', // Fraud specific prevention
  '200480': '#428a3f', // Card Transactions Risk
  '401996': '#800020', // LP First Party Fraud
}
